<mat-grid-list [cols]="1">
  <huge-row>
    <mat-col>
      <form [formGroup]="formGroup">
        <mat-list-item class="search-input ion-margin mat-justify-content-center" lines="none">
          <input matInput formControlName="searchControl" type="text" placeholder="Search" (keyup.enter)="searchNotes()" />
          <mat-icon slot="end" color="primary" (click)="searchNotes()">search</mat-icon>
        </mat-list-item>
      </form>
    </mat-col>
  </huge-row>
  <div #scrollMe [scrollTop]="scrollMe.scrollHeight" class="chat-container">
    @if (showSpinner) {
    <mat-spinner></mat-spinner>
    } @if (deviceNotes.length == 0) {
    <p class="text-align-center">No results found.</p>
    } @if (deviceNotes.length > 0) {
    <div>
      @for (note of deviceNotes; track note) {
      <huge-row class="chat-container">
        @if (userId !== 0 && userId !== note.UserID) {
        <mat-col size="9" class="message external-message">
          <b>{{ note.User }}</b>
          <br />
          <span>{{ note.Message }}</span>
          <div class="time">
            <br />
            {{ note.Timestamp | date : 'shortTime' }}
          </div>
        </mat-col>
        } @if (userId !== 0 && userId == note.UserID) {
        <mat-col offset="3" size="9" class="message internal-message">
          <b>You</b>
          <br />
          <span>{{ note.Message }}</span>
          <div class="time">
            <br />
            {{ note.Timestamp | date : 'shortTime' }}
          </div>
        </mat-col>
        }
      </huge-row>
      }
    </div>
    }
  </div>
  <huge-row class="text-area-section mat-align-items-center mat-padding-none">
    <mat-col size="10">
      <textarea cdkTextareaAutosize rows="3" [(ngModel)]="newNote" class="message-input"></textarea>
    </mat-col>
    <mat-col size="2">
      <button mat-button expand="block" fill="clear" color="primary" [disabled]="newNote === ''" class="message-btn" (click)="addNote()">
        <mat-icon slot="icon-only">send</mat-icon>
      </button>
    </mat-col>
  </huge-row>
</mat-grid-list>
